import { createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import Mdx from "#/components/MdxRemote";
import { metadataToHead } from "#/lib/seo";

export default function Page() {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <main id="content" className="mx-auto mt-24 max-w-3xl space-y-10">
        <h1 className="text-center text-5xl">Privacy Policy</h1>

        <section className="mx-8 space-y-5">
          <Mdx source={content} />
        </section>
      </main>
      <Footer />
    </>
  );
}

const content = `
## 1. Information Collection
- **Personal Information**: We collect personal details such as your name, email address, and professional qualifications when you register on our site.
- **Job Preferences**: Information regarding your job preferences, such as location and type of employment, is gathered to tailor job alerts and recommendations.
- **Usage Data**: Information on how you interact with our website, such as page visits and time spent on pages.

## 2. Use of Information
- **Job Alerts**: Your email is used to send personalized job alerts based on your preferences.
- **Recruiter Interaction**: If you express interest in working with a recruiter, your information will be used to facilitate this connection.
- **Improving Services**: We use collected data to improve website functionality and user experience.

## 3. Sharing of Information
- **With Employers**: Your professional information may be shared with potential employers if you express interest in a specific job listing.
- **Legal Requirements**: We may disclose your information if required by law or if necessary to protect our rights.

## 4. Data Security
We implement industry-standard security measures to protect your data from unauthorized access, alteration, or destruction.

## 5. User Rights
You have the right to access, amend, or delete your personal information. Please contact us for such requests.

## 6. Changes to the Privacy Policy
We may update this policy periodically. The effective date at the top of this policy will indicate the last update.


## 7. Contact Information
- For any questions regarding this policy, please contact [roamdoc.com/contact-roamdoc](https://roamdoc.com/contact-roamdoc).
`;

export const metadata = {
  title: "Privacy Policy  • Roamdoc",
  description: "Privacy Policy for Roamdoc.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/privacy-policy`,
  },
};

export const Route = createFileRoute("/(legal)/privacy-policy/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
